import "./ExcelFieldSuggestions.css";

export default function ExcelFieldSuggestions({ suggestions = [] }) {
  if (!suggestions.length) return null;

  return (
    <section className="excel-field-suggestions">
      <div className="excel-field-suggestions__header">
        <h3>Nieuwe veldsuggesties</h3>
        <p>
          POWER kan deze FieldConfigs automatisch aanmaken tijdens de import.
        </p>
      </div>

      <div className="excel-field-suggestions__grid">
        {suggestions.map((field, index) => (
          <div
            key={`${field.key}-${index}`}
            className="excel-field-suggestions__card"
          >
            <div>
              <h4>{field.label}</h4>
              <code>{field.key}</code>
            </div>

            <div className="excel-field-suggestions__meta">
              <span>Type: {field.type}</span>
              <span>Kolom: {field.excel_column || field.column || "-"}</span>
              <span>Header: {field.excel_header || field.header || "-"}</span>
            </div>

            {Array.isArray(field.options) && field.options.length > 0 && (
              <div className="excel-field-suggestions__options">
                {field.options.map((option) => (
                  <span key={option.value}>{option.label || option.value}</span>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
